module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--help"
  }, [_c('div', {
    staticClass: "help"
  }, [_c('div', {
    staticClass: "help__content"
  }, [_c('h1', {
    staticClass: "h1 mt mb2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Help us understand a little more about what you’re going through")]), _vm._v(" "), _c('p', {
    staticClass: "p fw-bold"
  }, [_vm._v("Are you experiencing either of these?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "No, I am not"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextQuestion.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "primary",
      "link": "risk",
      "label": "Yes, I am"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "help__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.illustration,
      "alt": ""
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mb"
  }, [_c('li', {
    staticClass: "li"
  }, [_vm._v("Any type of violence")]), _vm._v(" "), _c('li', {
    staticClass: "li"
  }, [_vm._v("Thoughts of hurting yourself or others")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d5aff8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/help/HelpMyself.vue
// module id = 557
// module chunks = 0